import React from 'react';
import css from './SignupForm.module.css';
import { FieldSelect, FieldTextInput } from '../../../components';
import { required } from '../../../util/validators';
import { stateTerritoryOptions } from '../../../config/configExtras';
import classNames from 'classnames';
const FanAddressFormFields = ({ intl }) => {
  return (
    <div className={css.newLocationForm}>
      <div className={classNames(css.formRow, css.fullWidth)}>
        <FieldTextInput
          className={css.formFld}
          type="text"
          id="streetAddress"
          name="streetAddress"
          label={intl.formatMessage({
            id: 'SignupForm.FanAddressFormFields.streetAddressLabel',
          })}
          placeholder={intl.formatMessage({
            id: 'SignupForm.FanAddressFormFields.streetAddressPlaceholder',
          })}
        />
      </div>
      <div className={classNames(css.formRow, css.fullWidth)}>
        <FieldTextInput
          className={css.formFld}
          type="text"
          id="city"
          name="city"
          placeholder={intl.formatMessage({
            id: 'SignupForm.FanAddressFormFields.cityPlaceholder',
          })}
          label={intl.formatMessage({
            id: 'SignupForm.FanAddressFormFields.cityLabel',
          })}
        />
      </div>
      <div className={classNames(css.formRow, css.fullWidth)}>
        <FieldSelect
          id="state"
          name="state"
          className={css.field}
          label={intl.formatMessage({
            id: 'SignupForm.FanAddressFormFields.stateLabel',
          })}
          validate={required(
            intl.formatMessage({ id: 'SignupForm.FanAddressFormFields.stateRequired' })
          )}
        >
          <option disabled value="">
            {intl.formatMessage({
              id: 'SignupForm.FanAddressFormFields.statePlaceholder',
            })}
          </option>
          {stateTerritoryOptions.map(state => (
            <option key={state.key} value={state.label}>
              {state.label}
            </option>
          ))}
        </FieldSelect>
      </div>
      <div className={classNames(css.formRow, css.fullWidth)}>
        <FieldTextInput
          className={css.formFld}
          type="text"
          id="zipCode"
          name="zipCode"
          label={intl.formatMessage({
            id: 'SignupForm.FanAddressFormFields.zipCodeLabel',
          })}
          placeholder={intl.formatMessage({
            id: 'SignupForm.FanAddressFormFields.zipCodePlaceholder',
          })}
        />
      </div>
    </div>
  );
};

export default FanAddressFormFields;
